var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-card-foot-stat',{attrs:{"value":_vm.value,"text":"Weight","raw":true,"invalid":_vm.value === 0}})
}
var staticRenderFns = []

export { render, staticRenderFns }